export default "https://cdn.questicon.mathletics.com/assets/images/fluency-fail-fluffy-09d168625313f2a7697777aeaecfc6e7.png";